<div class="note-item">
  <img src="/assets/images/user.png" class="author-image">
  <div class="info">
    <div class="first-line">
      <div class="author-name" appFsMask>{{note.user.firstName + ' ' + note.user.lastName}}</div>
      <div class="time">{{note.createdDate | amFromUtc | amTimeAgo}}</div>
      @if (!parent) {
        <div class="reply" (click)="clickReplyCallback(note)">&bull; Reply</div>
      }
      <div class="clear"></div>
    </div>

    @if (parent) {
      <div class="reply-to">to <span appFsMask>{{parent.user.firstName + ' ' + parent.user.lastName}}</span>
    </div>
  }
  <div class="text" appFsMask>{{note.description}}</div>
</div>
<div class="clear"></div>
</div>
